import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';

import HierarchyItemCard from '../../ProUserPage/components/HierarchyItemCard';
import { HIERARCHY_ITEM_TYPE } from '../../../../../../../constants/albums';
import { BASENAME } from '../../../../../../../constants/basenames';

const propTypes = {
  year: PropTypes.string.isRequired,
  hierarchyResults: PropTypes.arrayOf(PropTypes.object).isRequired,
  authenticated: PropTypes.bool,
};

const YearResultListing = ({ year, hierarchyResults, authenticated }) => {
  const history = useHistory();
  return (
    <div className="year-result-listing">
      <h4 className="text-bold text-light px-2 px-md-5">{year}</h4>

      <div className="year-result-listing-grid">
        {hierarchyResults.map(hierarchyItem => {
          const viewLinkTarget = authenticated
            ? `/app/${BASENAME.SHUTTERBUG}/hierarchy-items/${hierarchyItem.id}`
            : `/galleries/view/${
                hierarchyItem.type === HIERARCHY_ITEM_TYPE.ALBUM_FOLDER
                  ? 'folder'
                  : 'album'
              }/${hierarchyItem.id}`;

          return (
            <div key={hierarchyItem.id}>
              <HierarchyItemCard
                hierarchyItem={hierarchyItem}
                onItemClick={() => {
                  history.push(viewLinkTarget);
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

YearResultListing.propTypes = propTypes;

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export default compose(connect(mapStateToProps))(YearResultListing);
